import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { GlobalLoadingBar } from './GlobalLoadingBar';

export function MainLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <GlobalLoadingBar />
      <Header />
      <main className="flex-1 overflow-y-auto bg-white p-4 pb-[43px] sm:p-6 sm:pb-[43px] lg:px-14">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
